import { useCallback } from 'react';

const useCombinedRefs = (externalRef, internalRef) => useCallback((node) => {
    // eslint-disable-next-line no-param-reassign
    internalRef.current = node;
    if (typeof externalRef === 'function') {
        externalRef(node);
    }
    else if (externalRef) {
        // eslint-disable-next-line no-param-reassign
        externalRef.current = node;
    }
}, [externalRef, internalRef]);

export { useCombinedRefs };
